import { render, staticRenderFns } from "./RevolutResultModal.vue?vue&type=template&id=700e58e0&scoped=true&"
import script from "./RevolutResultModal.vue?vue&type=script&lang=js&"
export * from "./RevolutResultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e58e0",
  null
  
)

export default component.exports